import classnames from 'classnames';
import styles from './Button.module.scss';

export default function Button({children, light, grey, dark, className, onClick}) {
  return (
    <button className={classnames(styles.container, className, {
      [styles.light]: light,
      [styles.grey]: grey,
      [styles.dark]: dark,
    })} onClick={onClick}>
      {children}
    </button>
  )
}